import { postInviteUsers } from '../../../api';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPostAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const securityInvitationsSendPostAsyncSlice = createPostAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.USER_INVITED),
			type: SagaYieldType.Every
		}
	],
	name: 'SecurityInvitationsSend',
	receive: true,
	request: true,
	requestHandler: postInviteUsers,
	retainDataOnRequest: false
});
